$(document).on('click', '.subscription-selection-btn-sidebar', function(){
    var type = $(this).data('type');
    var form = $(this).data('form');
    if($('#'+form).find('.subscription_selection #'+type).hasClass('active')){
    }else{
      console.log(type);
      console.log(form);
      $('#'+form).find('.subscription_selection').removeClass('active');
      $('#'+form).find('.product-subscription__options_container #'+type).addClass('active');
      $('#'+form).find('.subscription-selection-btn-sidebar').removeClass('selected');

      $(this).addClass('selected');
      if(type == 'subsave'){
        $('#'+form).find('[name="selling_plan"]').attr('disabled', false);
        $('#'+form).find('span[data-product-price]').text($('#'+form).find('span[data-subscription-discounted-price]').text());
        $('.original_price').show();
        //$('.original_price').text($('#'+form).find('span[data-original-price]').text());
      }else{
        $('#'+form).find('[name="selling_plan"]').attr('disabled', true);
        $('#'+form).find('span[data-product-price]').text($('#'+form).find('span[data-original-price]').text());
        $('.original_price').hide();
      }
    }
  });
$(document).ready(function() {
  var pathname = window.location.pathname;
  const myArray = pathname.split("/")[5];
  if(myArray == 'subscriptions'){
    $('#recharge-te ul .js-subscriptions-page').addClass('active');
    $('#recharge-te ul .js-schedule-page').removeClass('active');
    $('#recharge-te ul .js-orders-page').removeClass('active');
    $('#recharge-te ul .js-addresses-page').removeClass('active');
    $('#recharge-te ul .js-payment_methods-page').removeClass('active');
  }
  if(myArray == 'schedule'){
    $('#recharge-te ul .js-subscriptions-page').removeClass('active');
    $('#recharge-te ul .js-schedule-page').addClass('active');
    $('#recharge-te ul .js-orders-page').removeClass('active');
    $('#recharge-te ul .js-addresses-page').removeClass('active');
    $('#recharge-te ul .js-payment_methods-page').removeClass('active');
  }
  if(myArray == 'orders'){
    $('#recharge-te ul .js-subscriptions-page').removeClass('active');
    $('#recharge-te ul .js-schedule-page').removeClass('active');
    $('#recharge-te ul .js-orders-page').addClass('active');
    $('#recharge-te ul .js-addresses-page').removeClass('active');
    $('#recharge-te ul .js-payment_methods-page').removeClass('active');
  }
  if(myArray == 'shipping'){
    $('#recharge-te ul .js-subscriptions-page').removeClass('active');
    $('#recharge-te ul .js-schedule-page').removeClass('active');
    $('#recharge-te ul .js-orders-page').removeClass('active');
    $('#recharge-te ul .js-addresses-page').addClass('active');
    $('#recharge-te ul .js-payment_methods-page').removeClass('active');
  }
  if(myArray == 'payment_methods'){
    $('#recharge-te ul .js-subscriptions-page').removeClass('active');
    $('#recharge-te ul .js-schedule-page').removeClass('active');
    $('#recharge-te ul .js-orders-page').removeClass('active');
    $('#recharge-te ul .js-addresses-page').removeClass('active');
    $('#recharge-te ul .js-payment_methods-page').addClass('active');
  }
  console.log(myArray);
});

const bindContractButtons = () => {
  const msContractButtons = document.querySelectorAll("[data-ms-contract-button]");

  if (msContractButtons.length > 0) {
    msContractButtons.forEach(button => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();

        const url = button.getAttribute("href");
        window.history.pushState({}, "", url);

        const loading = document.querySelector('[data-product-info-loading]');
        loading.classList.add("show");

        const res = await fetch(url)
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, "text/html");
        document.querySelector(".product-monthly-subscription").innerHTML = doc.querySelector(".product-monthly-subscription").innerHTML;

        // insert dynamic selling_plan
        const sellingPlan = document.createElement("input");
        sellingPlan.type = "hidden";
        sellingPlan.name = "selling_plan";
        sellingPlan.value = '';
        if (url.includes('barkbox-12-month')) {
          sellingPlan.value = '1864761431';
        } else if (url.includes('barkbox-6-month')) {
          sellingPlan.value = '1266352215';
        } else if (url.includes('barkbox-monthly')) {
          sellingPlan.value = '1266319447';
        } else if (url.includes('superchewer-12-month')) {
          sellingPlan.value = '1266483287';
        } else if (url.includes('superchewer-6-month')) {
          sellingPlan.value = '1266450519'
        } else if (url.includes('superchewer-monthly')) {
          sellingPlan.value = '1266417751'
        }

        const pdpForm = document.querySelector(".product-info__buy-buttons form");
        pdpForm.prepend(sellingPlan);

        bindContractButtons();

        loading.classList.remove("show");
      })
    })
  }
}

bindContractButtons();
